import { connect, FormikValues } from 'formik'
import { cloneDeep } from 'lodash'
import styled from 'styled-components'
import { string } from 'yup'

import Label from '@/components/Label'
import { Row } from '@/components/StyledComponents'
import { Popover } from '@/components/TailwindUI/Popover'
import { VariableInputContainer } from '@/pages/SpaceAppBuilder/components/StyledComponents'
import VariableAutoComplete from '@/pages/SpaceAppBuilder/components/VariableInputDropdown'
import { useWorkflowFeature } from '@/pages/SpaceAppBuilder/FeaturesPage/WorkflowFeatureContext'
import convertJSONtoSchema from '@/pages/SpaceAppBuilder/utilities/convertJSONToSchema'
import { FieldTypes, FileDownloadStepData, StepData, Variable } from '@/pages/SpaceAppBuilder/utilities/interfaces'

const StyledRow = styled(Row)`
  justify-content: flex-start;
  margin-bottom: 5px;
`

type FileDownloadProps = {
  readOnly?: boolean
}

const getValidationSchema = () => {
  return {
    assetId: string().required('Asset Id/Download URL is a required field.')
  }
}

const getInitialValues = (stepData: FileDownloadStepData): StepData => ({ assetId: stepData.assetId })

const getNetworkRequestObject = (data: { triggerData: any; stepData: any }) => {
  const updatedValues: any = cloneDeep(data)
  const { stepData } = data
  if (!stepData.assetId) return data

  const outputJson = {
    extractedText: '',
    fileSize: 0,
    numberOfCharacters: 0
  }

  //used to define variables for the step
  updatedValues.output = convertJSONtoSchema(outputJson)

  return updatedValues
}

const FileDownloadOperation = ({ formik, readOnly = false }: FileDownloadProps & FormikValues) => {
  const { getVariablesForStep } = useWorkflowFeature()
  const variables = getVariablesForStep()

  const onSelectVariable = (variable: Variable, formikName: string) => {
    formik.setFieldValue(formikName, variable.name)
  }

  return (
    <>
      <StyledRow>
        <Label required>File Asset Id or Pre-authenticated pdf download url</Label>
        <Popover
          tooltipMessage={`Asset Id is the identifier returned from the Upload File step. A URL must be to a pre-authenticated pdf download (ie. MS Graph Action: Get Share By Resource Type response includes '@microsoft.graph.downloadUrl').`}
        />
      </StyledRow>
      <VariableInputContainer>
        <VariableAutoComplete
          readOnly={readOnly}
          name={'stepData.assetId'}
          variables={variables}
          validVariableTypes={[FieldTypes.STRING]}
          placeholder={`Enter Asset Id or URL`}
          // @ts-expect-error
          onSelectOption={onSelectVariable}
          showValidationMessage={true}
          required
        />
      </VariableInputContainer>
    </>
  )
}

export default connect(FileDownloadOperation)

export { getInitialValues, getValidationSchema, getNetworkRequestObject }
